import { Injectable, OnDestroy } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from './localStorage.service';
import { Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class MessageService implements OnDestroy {
  translationText:any = {};
  subscription = new Subscription();

  constructor(
    private _message: NzMessageService,
    private translateService: TranslateService,
    private _localStorage: LocalStorageService
  ) {
    this.translateService.use(this._localStorage.get('language') || 'en_US');
    this.subscription.add(
      this.translateService.get(['APP']).subscribe((translation) => {
        this.translationText = translation.APP || {};
      })
    );
  }

  // type can be 'success', 'error', 'warning'
  showSuccess(message: string, duration?: number) {
    this._message.create(
      'success',
      this.toSentenceCase(message),
      duration ? { nzDuration: duration } : null
    );
  }

  showError(
    message: string =  this.translationText?.OOPS_SEC_ERROR_OCC,
    duration?: number
  ): void {
    this._message.create(
      'error',
      this.toSentenceCase(message),
      duration ? { nzDuration: duration } : null
    );
  }

  info(message: string, duration?: number): void {
    this._message.create(
      'info',
      this.toSentenceCase(message),
      duration ? { nzDuration: duration } : null
    );
  }

  handleErrors(message) {
    if (Array.isArray(message) && message.length) {
      message.forEach((error) => this.showError(error));
    } else if (typeof message === 'string') {
      this.showError(message);
    }
  }

  toSentenceCase(message: string): string {
    if (!message) return '';
    return message.charAt(0).toUpperCase() + message.slice(1).toLowerCase();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
